import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 50px;
`;

export default Container;
